export default {
  black: '#000',
  white: '#fff',
  gray: '#595959',
  red: '#c90000',
  yellow: '#f0ff99',
  green: '#088e6c',
};
